'use client';

import { Clock } from 'lucide-react';

interface EstimatedReadingTimeProps {
  minutes: number;
}

export default function EstimatedReadingTime({ minutes }: EstimatedReadingTimeProps) {
  // Ensure minutes is a number and has a reasonable default
  const readingTime = typeof minutes === 'number' && !isNaN(minutes) ? minutes : 5;

  return (
    <span className="flex items-center text-sm">
      <Clock className="mr-1 h-4 w-4" />
      {readingTime} min read
    </span>
  );
}
